import request from '@/utils/request'

export function logGrid(page, size, data) {
  return request({
    url: '/api/log/logGrid/' + page + '/' + size,
    method: 'post',
    data,
    loading: true
  })
}

export function opTypes() {
  return request({
    url: '/api/log/opTypes',
    method: 'post',
    loading: true
  })
}

export function exportExcel(data) {
  return request({
    url: '/api/log/export',
    method: 'post',
    loading: true,
    responseType: 'blob',
    data
  })
}

export function loginTraceList(data) {
  return request({
    url: '/sys/loginTrace/pageList',
    method: 'post',
    data
  })
}


// 业务操作日志分页查询
export function bizOperationLogList(data) {
  return request({
    url: '/sys/bizOperationLog/pageList',
    method: 'post',
    data
  })
}

// 操作分类下拉
export function bizOperationCategoryOptions(data) {
  return request({
    url: '/sys/bizOperationLog/operationCategoryOptions',
    method: 'get',
    params: data
  })
}
